// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-5ac595ee] {\n  color: #999;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n}\n[data-v-5ac595ee].el-input__suffix {\n  right: 10px;\n  line-height: 32px;\n}\n.selWidth[data-v-5ac595ee] {\n  width: 460px !important;\n}", ""]);
// Exports
module.exports = exports;
